export default {
  SET_ABOUT_CONTEXT: function (state, payload) {
    state.aboutContext = payload;
  }
}
